module.exports = __webpack_public_path__ + "img/substrate-hexagon.d3f5a498.svg";